export const ValidationMessage = {
  WEBSITE_ADDRESS: 'Website address has the wrong format. E.g.: http://www.your-site.com',
};
